import Skeleton from '~/components/Skeleton';
import SwipeA from '~/components/Skeleton/SwipeA';

const RecentlyViewedProductsSkeleton = () => {
  return (
    <>
      <div className="h-12 w-full bg-gray-100" />
      <div className="my-24">
        <Skeleton width={180} height={26} className="ml-20" />
        <div className="ml-20 mt-16">
          <SwipeA />
        </div>
      </div>
    </>
  );
};

export default RecentlyViewedProductsSkeleton;
